export const SIGNUP = "SIGNUP";
export const SIGNUP_SUCCESSFUL = "SIGNUP_SUCCESSFUL";
export const SIGNUP_FAILED = "SIGNUP_FAILED";


export const RESET = "RESET";
export const RESET_SUCCESSFUL = "RESET_SUCCESSFUL";
export const RESET_FAILED = "RESET_FAILED";
